/**
 * Runtime guard against non-image files. The HTML `<input accept="...">`
 * attribute and `<a href="...">` MIME hints are advisory — users can override
 * them via "Files of type: All" on macOS, Windows, and drag-drop — so any code
 * path that consumes a user-supplied File must validate the type itself.
 *
 * Returns true for browser-detected images (`image/*`) and HEIC/HEIF files,
 * which some browsers report with an empty MIME type.
 */
export function isImageFile(file: File): boolean {
  if (file.type.startsWith('image/')) return true;
  return /\.(heic|heif)$/i.test(file.name);
}
